module.exports = __webpack_public_path__ + "static/media/star-white.f298aba3.png";